import { KText } from '@/ui-library/components/text';
import { Flex, Box, Button } from '@chakra-ui/react';
import { useIsMobile } from '@/hooks/use-IsMobile';

export const Fallback = ({ error = {} }) => {
  const isMobile = useIsMobile();

  return (
    <Flex
      flex="1"
      height="100%"
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      px={isMobile ? '24px' : 0}
    >
      <Box width={isMobile ? '100%' : '450px'} textAlign="center">
        <KText variant="heading_2" mt="16px">
          {error?.name === 'ChunkLoadError'
            ? 'Oops! Let us fetch that page for you again.'
            : 'Oops! We dropped the ball it seems. Can you refresh the page?'}
        </KText>
      </Box>
      {error?.name !== 'ChunkLoadError' && (
        <Button
          variant="primary"
          onClick={() => window.location.reload()}
          mt="16px"
        >
          Refresh
        </Button>
      )}
    </Flex>
  );
};
